import React from 'react';
import './Componenst.css';
import GunModel from '../models/GunModel';
import SearchModel from '../models/SearchModel';
import loading from '../../img/loading.gif';
import { decryptAes, storeKey, encryptAes } from '../../crypto-utils';
import { ip } from './../../constants';
import Swal from 'sweetalert2/src/sweetalert2'
import '@sweetalert2/themes/dark/dark.css';
import { createGun, showError } from '../ViewCreator';

function Gun({ changeSearch, searchModel, setView, addNew = () => {}, isAdd = false }) {

    const personModel = new GunModel();


    const clearSubmit = () => {
        document.getElementById('descGun').value     = '';
    document.getElementById('numberGun').value     = '';
    document.getElementById('typeGun').value     = '';
    personModel.descGun = ''
    personModel.numberGun = ''
    personModel.typeGun = ''
    if (searchModel != undefined ) {
      searchModel.gun.descGun = ''
      searchModel.gun.numberGun = ''
      searchModel.gun.typeGun = ''
    }
    }

    const addSubmit = () => {
        if (personModel.typeGun == undefined || personModel.typeGun == '') {
            showError('Тип не може бути пустим')
            return;
        }

        if (personModel.numberGun == undefined || personModel.numberGun == '') {
            showError('Номер не може бути пустим')
            return;
        }

          isUniq()
    }

    const isUniq = () => {
        var path = ip + '/api/gun/search';
        personModel.searchModel = new SearchModel()
        var pp = new GunModel();
        pp.typeGun = personModel.typeGun
        pp.numberGun = personModel.numberGun
        var bd = encryptAes(JSON.stringify(pp))
        const requestOptions = {
          headers: {
            'Content-Type': 'Content-type: text/html'
          },
          credentials: 'include',
          uri: path,
          encoding: 'latin1',
          body: bd,
          method: 'POST'
        };
        fetch(path, requestOptions)
          .then()
          .then(response => { return response.arrayBuffer() })
          .then((buffer) => {
            const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
            const text = decoder.decode(buffer);
            try {
              var result = JSON.parse(text);
               showError(result.msg)
            } catch (error) {
              const decryptedText = decryptAes(text);
              var result = JSON.parse(decryptedText);
              storeKey('test_data', result.key);
    
              if (result.data.length > 0) {
                Swal.fire({
                    title: 'Запис уже існує',
                    //text: "Оновити інформацію?",
                    icon: 'warning',
                    html:
                    'Запис з такими даними вже існує, Ви можете ' +
                    '<a href="/gun?id='+result.data[0].id+'" style="color:#FFFFFF;"  target="_blank">переглянути запис</a>',
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: 'ОК',
                      denyButtonText: 'Оновити',
                      background: '#2B2B2B',
                      color: '#FFF'
                    }).then((result) => {
                    })
                  sendSearch()
              } else {
                Swal.fire({
                  title: 'Ви дійсно бажаєте створити новий запис',
                  //text: "Оновити інформацію?",
                  icon: 'question',
                  html:
                  '',
                  showDenyButton: false,
                  showCancelButton: true,
                  confirmButtonText: 'Створити',
                  denyButtonText: 'Оновити',
    
                  background: '#2B2B2B',
                  color: '#FFF'
                }).then((result) => {
                  addNewGun()
                  })
                
              }
            }
          })
      }

      const addNewGun = () => {
        var path = ip + '/api/gun/add';
        personModel.searchModel = new SearchModel()
        var bd = encryptAes(JSON.stringify(personModel))
        const requestOptions = {
          headers: {
            'Content-Type': 'Content-type: text/html'
          },
          credentials: 'include',
          uri: path,
          encoding: 'latin1',
          body: bd,
          method: 'POST'
        };
        fetch(path, requestOptions)
          .then()
          .then(response => { return response.arrayBuffer() })
          .then((buffer) => {
            const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
            const text = decoder.decode(buffer);
            try {
              var result = JSON.parse(text);
               showError(result.msg)
              
    
            } catch (error) {
              const decryptedText = decryptAes(text);
              var result = JSON.parse(decryptedText);
              storeKey('test_data', result.key);
              if (isAdd) {
                addNew(result.data, 20006)
                clearSubmit()
              } else {
              window.open("/edit/gun?id="+result.data, "_self")
              }
            }
          })
      }

    const sendGunFullScreen = (id) => {
        window.open("/gun?id=" + id)
    }

    const sendGun = (id) => {
        var path = ip + '/api/gun/id';
       var bd = encryptAes(id)
           const requestOptions = {
             headers: {
               'Content-Type': 'Content-type: text/html; charset=win1251'
             },
             credentials: 'include',
             uri: path,
             encoding: 'latin1',
             body: bd,
             method: 'POST'
           };
           fetch(path, requestOptions)
           .then()
           .then(response => { return response.arrayBuffer() })
           .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)
                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);

                    var zz = []
                
                    var addr = result.data
                    
                    zz.push(createGun(addr))
    
                   

                    setView(zz)
                }
            })
    }


    const handleSubmit = (e) => {
        sendSearch();
        e.preventDefault();
    }

    const sendSearch = () => {
        var path = ip + '/api/gun/search';
        personModel.searchModel = new SearchModel()
        var bd = encryptAes(JSON.stringify(personModel))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);

                    var zz = []

                    for (let index = 0; index < result.data.length; index++) {
                        var z = document.createElement('div'); // is a node
                        var pers = result.data[index]
                        var i = pers.id
                        z.className = "listItem"
                        z.innerHTML = "<p align=\"left\">- "+pers.typeGun + " "+ pers.numberGun;
                        z.style.display = "block";
                        const cl = i => () => {
                            sendGun(i)
                        }
                        const dblcl = i => () => {
                            sendGunFullScreen(i)
                        }
                       // z.onclick = cl(pers.id)
                        z.ondblclick = dblcl(pers.id)
                        var per = new GunModel()
                        per.id = pers.id
                        z.value = per
                        zz.push(z);
                    }
                    changeSearch(zz)
                }
            })
    }

    const handleKeyPress = (event) => {
        event = event || window.event;
        if (event.key === 'Tab') {
            closeAllHelp();
        }
        if (event.key === 'Enter') {
            closeAllHelp();
        }
        if (event.key === 'Escape') {
            closeAllHelp();
        }
    }
    const closeAllHelp = () => {
        var a = document.getElementsByClassName("list");
        for (let index = 0; index < a.length; index++) {
            a[index].innerHTML = "";
        }
    }
    const changedfield = (id) => {
        var input = document.getElementById(id)
        if (input != null) {
            if (input.value.length > 0) {
                document.getElementById(id + "List").innerHTML = "";
                sendHelp(input.value, id);
            } else {
                document.getElementById(id + "List").innerHTML = "";
            }
        }
    }

    const sendHelp = (value, id) => {
        var path = ip + '/api/help/';
        var bd = encryptAes(JSON.stringify({
            "value": value,
            "type": id
        }))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    var l = result.data.list;
                    for (let index = 0; index < l.length; index++) {
                        var z = document.createElement('div'); // is a node
                        z.className = "listItem"
                        z.innerHTML = l[index];
                        z.style.display = "block";
                        z.href = "#";
                        z.onclick = () => {

                            document.getElementById(id).value = l[index]
                            document.getElementById(id + "List").innerHTML = "";

                            
                              if(id=='typeGun'){
                                personModel.typeGun = l[index]
                              }
                              if(id=='numberGun'){
                                personModel.numberGun = l[index]
                              }
                              if(id=='descGun'){
                                personModel.descGun = l[index]
                              }

                        }
                        document.getElementById(id + "List").appendChild(z);

                    }
                }
            })








    }


        
    
      const typeGunchange = () =>  {
        personModel.typeGun = document.getElementById('typeGun').value
        changedfield('typeGun');
      }
    
      const numberGunchange = () =>  {
        personModel.numberGun = document.getElementById('numberGun').value
        changedfield('numberGun');
      }
    
      const descGunchange = () =>  {
        personModel.descGun = document.getElementById('descGun').value
        changedfield('descGun');
      }


    const handleFocus = (event) => {
        closeAllHelp()
    };

    return (
        <div>
            <button id="clear-button-gun" className="clear-button-right" onClick={clearSubmit}>Очистити
            </button>
            <button id="add-button-gun" className="add-button-right" onClick={addSubmit}>Додати
            </button>
            <form onSubmit={handleSubmit} className="form">
                <input id="input-button-gun" className="input-button-right" type="submit" value="Пошук" />

               

          <div id="descGunDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="descGun" className="input-text" tabIndex="3" name="login" type="text" onChange={descGunchange}  placeholder="Опис" autoComplete="off"onKeyDown={handleKeyPress} onFocus={handleFocus}   />
            <div id="descGunList" className="list" />
          </div>

          <div id="numberGunDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="numberGun" className="input-text" tabIndex="2" name="login" type="text" onChange={numberGunchange}  placeholder="Номер" autoComplete="off"onKeyDown={handleKeyPress} onFocus={handleFocus}   />
            <div id="numberGunList" className="list" />
          </div>

          <div id="typeGunDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="typeGun" className="input-text" tabIndex="1" name="login" type="text" onChange={typeGunchange}  placeholder="Тип зброї" autoComplete="off"onKeyDown={handleKeyPress} onFocus={handleFocus}   />
            <div id="typeGunList" className="list" />
          </div>
            </form>
        </div>
    );
}

export default Gun;